import { Trans, useTranslation } from "react-i18next";
import { CheckboxLabel as BaseCheckboxLabel, CheckboxInput, CheckboxInputContainer } from "../Checkbox/Checkbox";
import { Error, HelpText, RequiredStar } from "../common";
import React, { MouseEvent, useCallback } from "react";
import styled from "styled-components";
import { emitEvent } from "../../../../utils/emitEvent/emitEvent";
import { marginBottom } from "../../../styles";
import { SharedInputProps } from "../Input";
export type TermsProps = SharedInputProps & {
  url: string;
};
const CheckboxLabel = styled(BaseCheckboxLabel)`
  a {
    text-decoration: none;
    color: ${({
  theme
}) => theme.brand.cssVars["--d-info"]};
  }
`;
const Container = styled.div`
  ${marginBottom.m}
`;
export function Terms({
  error,
  helpText,
  label: propsLabel,
  url,
  ...props
}: TermsProps) {
  const {
    t
  } = useTranslation();
  const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    const params = new URLSearchParams(window.location.search);
    const iFrameId = params.get("iFrameId") ?? "";
    const webview = params.get("webview")?.toLowerCase() === "true";
    if (webview) {
      event.preventDefault();
    }
    emitEvent({
      data: {
        iFrameId,
        url
      },
      name: "EXTERNAL_LINK_CLICKED"
    });
  }, [url]);
  const defaultLabel = <Trans i18nKey="termsAndConditionsLabel" components={{
    anchor:
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a href={url} target="_blank" rel="noreferrer noopener" onClick={handleClick} />
  }} />;
  const label = propsLabel ? <a href={url} target="_blank" rel="noreferrer noopener" onClick={handleClick}>
      {propsLabel}
    </a> : defaultLabel;

  /**
   * Links within labels are bad for accessibility, so we *must* have an aria
   * label for the input, and keep the displayed "label" unassociated from
   * the input, so that it just acts as a normal text block
   */
  const ariaLabel = props["aria-label"] ?? t("termsAndConditionsAriaLabel");
  const {
    required
  } = props;
  const hasError = !!error;
  return <Container data-sentry-element="Container" data-sentry-component="Terms" data-sentry-source-file="Terms.tsx">
      <CheckboxInputContainer error={hasError} data-sentry-element="CheckboxInputContainer" data-sentry-source-file="Terms.tsx">
        <CheckboxInput role="checkbox" error={hasError} aria-required={required} {...{
        ...props,
        "aria-label": ariaLabel
      }} data-sentry-element="CheckboxInput" data-sentry-source-file="Terms.tsx" />
        <CheckboxLabel data-sentry-element="CheckboxLabel" data-sentry-source-file="Terms.tsx">
          {label}
          {required ? <RequiredStar /> : null}
        </CheckboxLabel>
      </CheckboxInputContainer>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Terms.tsx">{helpText}</HelpText>
      {error ? <Error role="alert">{error}</Error> : null}
    </Container>;
}
export default Terms;